import { Getters } from 'vuex-smart-module';
import MoneyPlanFactsState from './state';

export default class MoneyPlanFactsGetters extends Getters<MoneyPlanFactsState> {}
